import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { cityListing, countryListing, languageListing } from "../api/apiHandler";

export const country = createAsyncThunk(
    "settings/country",
    async (payload , {rejectWithValue}) => {
        try {
            const response = await countryListing(payload);
            if(response?.code === 200 || response?.code === 404){
                return response.data;
            }
            else{
                return rejectWithValue(response);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const city = createAsyncThunk(
    "settings/city",
    async (payload , {rejectWithValue}) => {
        try {
            const response = await cityListing(payload);
            if(response?.code === 200 || response?.code === 404){
                return response.data;
            }
            else{
                return rejectWithValue(response);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const language = createAsyncThunk(
    "settings/language",
    async (payload , {rejectWithValue}) => {
        try {
            const response = await languageListing(payload);
            if(response?.code === 200 || response?.code === 404){
                return response.data;
            }
            else{
                return rejectWithValue(response);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

const initialState = {
    loading: false,
    countryListing:[],
    cityList:[],
    languageList:[],
    error: null,
    success: false,
};

const settingsSlice = createSlice({
    name: "settings",
    initialState, 
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(country.pending, (state) => {
                state.loading = true;
                state.error = null; // Reset error on new request
                state.success = false; // Reset success on new request
            })
            .addCase(country.fulfilled, (state, { payload }) => {
                // console.log("payload: ", payload);
                state.loading = false;
                state.countryListing = payload;
                state.success = true;
            })
            .addCase(country.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
                state.success = false;
            })
            .addCase(city.pending, (state) => {
                state.loading = true;
                state.error = null; // Reset error on new request
                state.success = false; // Reset success on new request
            })
            .addCase(city.fulfilled, (state, { payload }) => {
                // console.log("payload: ", payload);
                state.loading = false;
                state.cityList = payload;
                state.success = true;
            })
            .addCase(city.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
                state.success = false;
            })
            .addCase(language.pending, (state) => {
                state.loading = true;
                state.error = null; // Reset error on new request
                state.success = false; // Reset success on new request
            })
            .addCase(language.fulfilled, (state, { payload }) => {
                // console.log("payload: ", payload);
                state.loading = false;
                state.languageList = payload;
                state.success = true;
            })
            .addCase(language.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
                state.success = false;
            })
    },
});

export default settingsSlice.reducer;